<template>
	<div class="challenge-results">
		<el-dialog :visible.sync="dialogVisible" :show-close="false" :close-on-press-escape="false" custom-class="challenge-dialog"
			:close-on-click-modal="false">
			<div v-if="results.problem_number == results.correct_number" class="title challenge-fullpair"></div>
			<div v-else class="title challenge-halfpair">挑战结果</div>
			<div class="result-box">
				<div class="result-con">
					<p class="result-problem_number">总题数：<span>{{results.problem_number}}</span></p>
					<p class="result-correct_number">正确题数：<span>{{results.correct_number}}</span></p>
					<p class="result-txt">{{results.result_txt}}</p>
				</div>
				<div class="result-btn">
					<div class="button button-signout" @click="signoutDialog">退出</div>
					<div class="button button-lookingback" @click="lookingBack">回看</div>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		name: "challengeResults",
		components: {},
		props: {},
		data() {
			return {
				dialogVisible: false,
				results: {}, // 结果
			}
		},
		created() {},
		mounted() {},
		methods: {
			open(result) { // 打开弹窗
				this.results = result;
				this.dialogVisible = true;
			},
			close() { // 关闭弹窗
				this.dialogVisible = false;
			},
			signoutDialog() { // 退出
				this.$router.go(-1);
			},
			lookingBack() { // 回看
				this.$emit("lookingBack");
				this.close();
			}
		}
	}
</script>

<style lang="scss" scoped>
	.challenge-results {
		::v-deep.challenge-dialog {
      box-shadow: none;
			background-color: rgba(0, 0, 0, 0);
			width: 25.4rem;

			.el-dialog__header {
				display: none;
			}

			.el-dialog__body {
				padding: 0;
			}

			.title {
				width: 25.4rem;
				background-size: 100%;
				background-repeat: no-repeat;
				color: #FFF;
				font-size: 1.6rem;
				text-align: center;
				position: relative;
				z-index: 2;
			}

			.title.challenge-fullpair {
				height: 10.4rem;
				background-image: url(~@/assets/img/preliminaryClassic/challenge-fullpair.png);
			}

			.title.challenge-halfpair {
				height: 8rem;
				line-height: 4rem;
				background-image: url(~@/assets/img/preliminaryClassic/challenge-halfpair.png);
			}

			.result-box {
				color: #FFF;
				width: 22rem;
				height: 18.88rem;
				border-radius: 0.64rem;
				background-color: rgba(29, 78, 100, 1);
				padding-top: 5.12rem;
				position: relative;
				margin: -4rem auto 0;

				.result-con {
					height: 8.9rem;
					background-color: #1B7E94;
					text-align: center;
					font-size: 1.4rem;
					border-radius: 0.4rem;
					margin: 0 1.8rem 3.72rem 1.8rem;
					padding-top: 2rem;

					.result-problem_number,
					.result-correct_number {
						color: #B5FCFF;
						line-height: 2rem;

						span {
							color: #55FF79;
						}
					}

					.result-txt {
						margin-top: 0.8rem;
					}
				}

				.result-btn {
					display: flex;
					justify-content: space-around;

					.button {
						width: 7.6rem;
						height: 2.08rem;
						background-size: 100%;
						background-repeat: no-repeat;
						font-size: 1.04rem;
						text-align: center;
						line-height: 2.08rem;
						cursor: pointer;
						user-select: none;
					}

					.button.button-signout {
						background-image: url(~@/assets/img/preliminaryClassic/signout.png);
					}

					.button.button-lookingback {
						background-image: url(~@/assets/img/preliminaryClassic/ben.png);
					}
				}
			}
		}
	}
</style>
